"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getIndexOfNextSymbol_1 = __importDefault(require("./getIndexOfNextSymbol"));
var removeMethodHashes = function (str) {
    var ixOfHash = (0, getIndexOfNextSymbol_1.default)('#', Number.MAX_SAFE_INTEGER);
    var acc = '';
    var _loop_1 = function (remaining) {
        var hashIx = ixOfHash(remaining);
        var isOf = function (phrase) { return remaining.slice(hashIx, hashIx + phrase.length) === phrase; };
        acc =
            acc +
                (isOf('#this') || isOf('#root')
                    ? // if #this, keep it
                        remaining.slice(0, hashIx + 1)
                    : // otherwise  acc everything before the hash
                        remaining.slice(0, hashIx));
    };
    for (var remaining = str; remaining; // while there is something remaining
     remaining = remaining.slice(ixOfHash(remaining) + 1) // get everything after the hash
    ) {
        _loop_1(remaining);
    }
    return acc;
};
exports.default = removeMethodHashes;
//# sourceMappingURL=removeMethodHashes.js.map